import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { Quote } from "./quote.type";
import { QuoteTableService } from "./quote-table.service";

@Component({
  selector: "app-quotes",
  templateUrl: "./quote.component.html",
  styleUrls: ["./quote.component.scss"],
})
export class QuotesComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<Quote>;

  constructor(
    public quoteTableService: QuoteTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Methods

  ngOnInit(): void {
    this.tableConfig = this.quoteTableService.getQuotesTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddQuote = (): void => this.addQuote();

  // #endregion

  // #region Private Methods

  private addQuote = (): void => {
    this.router.navigate(["/quotes/create"]);
  };

  // #endregion
}
